import * as React from 'react';

import {TinyGreyCard} from 'shells/card/tiny-grey-card';
import {FileImageIcon} from 'shells/icon/svg/file-image-icon';
import {H1Icon} from 'shells/icon/svg/h1-icon';
import {H2Icon} from 'shells/icon/svg/h2-icon';
import {TextBlockIcon} from 'shells/icon/svg/text-block-icon';

import type {HeaderFieldType, ImageFieldType} from '../../../../types';

import styles from './add-card.module.css';

type Props = {
    onSelectHeaderField: (arg1: HeaderFieldType | ImageFieldType) => void;
};

export function HeaderCards(props: Props) {
    return (
        <div className={styles['grid-container']}>
            <TinyGreyCard
                icon={<H1Icon size={24} />}
                text='Header'
                onClick={() => props.onSelectHeaderField('HEADER')}
            />
            <TinyGreyCard
                icon={<H2Icon size={24} />}
                text='Subheader'
                onClick={() => props.onSelectHeaderField('SUBHEADER')}
            />
            <TinyGreyCard
                icon={<TextBlockIcon size={24} />}
                text='Text block'
                onClick={() => props.onSelectHeaderField('TEXT')}
            />
            <TinyGreyCard
                icon={<FileImageIcon size={24} />}
                text='Image'
                onClick={() => props.onSelectHeaderField('IMAGE')}
            />
        </div>
    );
}
